import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white p-8 flex flex-col items-center text-black font-serif" }
const _hoisted_2 = { class: "text-xl mb-32 w-full text-center flex justify-center items-end" }
const _hoisted_3 = { class: "px-2" }




export default /*@__PURE__*/_defineComponent({
  __name: 'CoverPage',
  props: {
  title: {
    type: String,
    default: '老年教育助力基层治理服层治理服层治理服务融合'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-5xl tracking-widest mt-32 mb-24 font-medium" }, "国家开放大学", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-4xl tracking-widest mb-24 font-medium" }, "毕业论文", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-normal" }, "题目：", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"w-full max-w-md space-y-4 text-lg\" data-v-524d108b><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>分 部：</span></div><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>学习中心：</span></div><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>专 业：</span></div><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>入学时间：</span></div><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>学 号：</span></div><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>姓 名：</span></div><div class=\"flex items-end\" data-v-524d108b><span class=\"w-24 text-justify-last shrink-0\" data-v-524d108b>指导教师：</span></div><div class=\"flex items-end justify-center mt-20\" data-v-524d108b><span class=\"mr-10\" data-v-524d108b>论文完成日期：</span><span class=\"mr-10\" data-v-524d108b>年</span><span data-v-524d108b>月</span></div></div>", 1))
  ]))
}
}

})